import { STORE_GETTER } from "../store/store"




export const webContentMixin = {

	computed: {

		webContentList(){
			return this.$store.getters[STORE_GETTER.BASE_MODEL]?.webContentList
		}
	

	},

	methods: {

		callBoove(){
			window.open("tel:+4687610266")
			
		},
		
		webContentHTML(name){


			if (this.webContentList){


				const webContent = this.webContentList?.find(webContent => webContent.name == name)
				return webContent
			}

			return null;
		}

	}
}



